const parseBoolean = (str?: string) => {
  if (!str) {
    return false;
  }
  try {
    return Boolean(JSON.parse(str));
  } catch (err) {
    return false;
  }
};

// // const DEFAULT_REVALIDATION = 1 * 60;

// export const REPOSITORY = process.env.NEXT_PUBLIC_PRISMIC_REPOSITORY_NAME;
// export const API_LOCALE = process.env.NEXT_PUBLIC_PRISMIC_REPOSITORY_LOCALE;
// export const API_TOKEN = process.env.NEXT_PUBLIC_PRISMIC_API_TOKEN;

// export const DEVTOOLS = parseBoolean(
//   process.env.DEVTOOLS ?? process.env.NEXT_PUBLIC_DEVTOOLS,
// );

// // export const SKIP_ARTICLES = parseBoolean(
// //   process.env.SKIP_ARTICLES ?? process.env.NEXT_PUBLIC_SKIP_ARTICLES,
// // // );
// // export const NO_BASE64_IMAGES = parseBoolean(
// //   process.env.NO_BASE64_IMAGES ?? process.env.NEXT_PUBLIC_NO_BASE64_IMAGES,
// // );
// // export const DEVELOPMENT = process.env.NODE_ENV === 'development';

// export const REDIS_URL = process.env.REDIS_URL ?? '';
// export const REDIS_PASSWORD = process.env.REDIS_PASSWORD;
// export const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

// // export const REVALIDATION_TIMEOUT = DEFAULT_REVALIDATION;
// // export const FACEBOOK_PIXEL = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL;
// // export const GOOGLE_ANALYTICS = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS;
// // export const GTM_ID = process.env.GTM_ID || 'GTM-PPRB4J';
// // export const CANONICAL_URL_BASE =
// //   process.env.NEXT_PUBLIC_CANONICAL_URL_BASE ||
// //   'https://arsskyrsla.landsbankinn.is';

export interface PrismicConfig {
  REPOSITORY?: string;
  API_LOCALE?: string;
  API_TOKEN?: string;
  DEVTOOLS: boolean;
  REDIS_URL?: string;
  REDIS_PASSWORD?: string;
  SENTRY_DSN?: string;
}

export const prismicConfic: PrismicConfig = {
  REPOSITORY: process.env.NEXT_PUBLIC_PRISMIC_REPOSITORY_NAME,
  API_LOCALE: process.env.NEXT_PUBLIC_PRISMIC_REPOSITORY_LOCALE,
  API_TOKEN: process.env.NEXT_PUBLIC_PRISMIC_API_TOKEN,
  DEVTOOLS: parseBoolean(
    process.env.DEVTOOLS ?? process.env.NEXT_PUBLIC_DEVTOOLS,
  ),
  REDIS_URL: process.env.REDIS_URL ?? '',
  REDIS_PASSWORD: process.env.REDIS_PASSWORD,
  SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
};
